import { mutations } from './user.d';

export default {
  /**
   * Initialize Current User
   */
  [mutations.setCurrentUser](state, user) {
    state.currentUser = user;
  },
  [mutations.setCurrentUserPremium](state, isPremium) {
    state.isCurrentUserPremium = isPremium;
  },

  [mutations.setCurrentUserPremiumExpiryDate](state, expiryDate) {
    state.currentUserPremiumExpiryDate = expiryDate;
  }
};
